import { useState } from 'react';
import { motion } from 'framer-motion';

const MenuButton = ({ isOpen, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="fixed top-4 right-4 md:top-6 md:right-10 z-[100] cursor-pointer p-3 md:p-4 flex items-center gap-3"
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid="menu-button"
    >
      {isOpen && (
        <motion.span
          className="text-[#c8c7c9] font-inter text-[11px] md:text-[12px] tracking-[0.1em] uppercase hidden sm:block"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          CLOSE
        </motion.span>
      )}
      <div className="flex flex-col items-end justify-center w-6 md:w-7 h-5 relative">
        {/* Line 1 - Full width */}
        <motion.div
          className="h-[2px] bg-[#c8c7c9] rounded-sm absolute right-0"
          animate={{ 
            rotate: isOpen ? 45 : 0, 
            top: isOpen ? '50%' : '0%',
            translateY: isOpen ? '-50%' : '0%',
            width: isOpen ? 22 : (isHovered ? 26 : 24)
          }}
          transition={{ duration: 0.3 }}
          style={{ transformOrigin: 'center' }}
        />
        {/* Line 2 - Medium width */}
        <motion.div
          className="h-[2px] bg-[#c8c7c9] rounded-sm absolute right-0 top-1/2 -translate-y-1/2"
          animate={{ 
            opacity: isOpen ? 0 : 1,
            width: isOpen ? 0 : (isHovered ? 20 : 16)
          }}
          transition={{ duration: 0.2 }}
        />
        {/* Line 3 - Short width */}
        <motion.div
          className="h-[2px] bg-[#c8c7c9] rounded-sm absolute right-0"
          animate={{ 
            rotate: isOpen ? -45 : 0, 
            bottom: isOpen ? '50%' : '0%',
            translateY: isOpen ? '50%' : '0%',
            width: isOpen ? 22 : (isHovered ? 14 : 10)
          }}
          transition={{ duration: 0.3 }}
          style={{ transformOrigin: 'center' }}
        />
      </div>
    </div>
  );
};

export default MenuButton;
